import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function FooterExpanded() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language && i18n.language.startsWith('pt')
    ? 'pt-PT'
    : (i18n.language && i18n.language.startsWith('es') ? 'es' : 'en');

  return (
    <footer className="bg-[#08091a] border-t border-white/10 py-12 px-6 text-text-muted text-sm">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="font-serif text-champagne mb-3">{t('footer.product')}</div>
            <ul className="space-y-1">
              <li><Link to="/" className="hover:text-champagne transition-colors">{t('common.home')}</Link></li>
              <li><Link to="/pricing" className="hover:text-champagne transition-colors">{t('common.pricing')}</Link></li>
              <li><Link to="/register" className="hover:text-champagne transition-colors">{t('common.signUp')}</Link></li>
              <li><Link to="/login" className="hover:text-champagne transition-colors">{t('common.signIn')}</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-serif text-champagne mb-3">Use cases</div>
            <ul className="space-y-1">
              <li><Link to="/use-cases/weddings" className="hover:text-champagne transition-colors">Weddings</Link></li>
              <li><Link to="/use-cases/corporate-events" className="hover:text-champagne transition-colors">Corporate</Link></li>
              <li><Link to="/use-cases/brand-activations" className="hover:text-champagne transition-colors">Brand activations</Link></li>
              <li><Link to="/use-cases/galas" className="hover:text-champagne transition-colors">Galas</Link></li>
              <li><Link to="/use-cases/multi-day-events" className="hover:text-champagne transition-colors">Multi-day events</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-serif text-champagne mb-3">{t('footer.resources')}</div>
            <ul className="space-y-1">
              <li><Link to="/blog" className="hover:text-champagne transition-colors">{t('common.blog')}</Link></li>
              <li><Link to="/about" className="hover:text-champagne transition-colors">{t('footer.ourStory')}</Link></li>
              <li><Link to="/pricing" className="hover:text-champagne transition-colors">{t('common.pricing')}</Link></li>
              <li><Link to="/status" className="hover:text-champagne transition-colors">Status</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-serif text-champagne mb-3">{t('footer.account')}</div>
            <ul className="space-y-1">
              <li><Link to="/about" className="hover:text-champagne transition-colors">{t('common.about')}</Link></li>
              <li>memouraa.com</li>
            </ul>
          </div>
        </div>
        <div className="pt-6 border-t border-champagne/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs">
          <p>© {new Date().getFullYear()} Memouraa. {t('footer.captureTheAura')}</p>
          <p className="italic">
            {t('footer.silverFernAttribution').replace(/The Silver Fern Company Inc\.$/, '')}
            <a href="https://www.thesilverfern.ca/" target="_blank" rel="noopener noreferrer" className="hover:text-champagne transition-colors hover:underline">
              The Silver Fern Company Inc.
            </a>
          </p>
        </div>
        <div className="mt-6 flex justify-end">
          <select
            onChange={e => i18n.changeLanguage(e.target.value)}
            value={currentLang}
            aria-label="Language"
            className="bg-transparent border border-white/10 rounded px-2 py-1 text-xs text-text-muted"
            data-testid="footer-lang-select"
          >
            <option value="en">English</option>
            <option value="pt-PT">Português (PT)</option>
            <option value="es">Español</option>
          </select>
        </div>
      </div>
    </footer>
  );
}
